"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionType;
(function (ConditionType) {
    ConditionType["LIMIT"] = "limit";
    ConditionType["FLUX"] = "flux";
    ConditionType["INTRUSION"] = "intrusion";
    ConditionType["STATUS"] = "status";
    ConditionType["TEMPERATURE"] = "temperature";
    ConditionType["HUMIDITY"] = "humidity";
    ConditionType["CO2"] = "co2";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
// Type guards
exports.isConditionLimit = function (condition) { return condition.type === ConditionType.LIMIT; };
exports.isConditionFlux = function (condition) { return condition.type === ConditionType.FLUX; };
exports.isConditionIntrusion = function (condition) { return condition.type === ConditionType.INTRUSION; };
exports.isConditionStatus = function (condition) { return condition.type === ConditionType.STATUS; };
exports.isConditionNotStatus = function (condition) {
    return condition.type !== ConditionType.STATUS;
};
exports.isConditionAtmosphere = function (condition) {
    return condition.type === ConditionType.CO2 || condition.type === ConditionType.TEMPERATURE || condition.type === ConditionType.HUMIDITY;
};
